// extracted by mini-css-extract-plugin
export var hero = "hero-module--hero--1Ngwp";
export var title = "hero-module--title--6KLcl";
export var left = "hero-module--left--18Rbm";
export var heroDescription = "hero-module--heroDescription--k1NNG";
export var right = "hero-module--right--2P5xd";